import { render, staticRenderFns } from "./exam-paper-preview.vue?vue&type=template&id=0fc41455&scoped=true&"
import script from "./exam-paper-preview.vue?vue&type=script&lang=ts&"
export * from "./exam-paper-preview.vue?vue&type=script&lang=ts&"
import style0 from "./exam-paper-preview.vue?vue&type=style&index=0&id=0fc41455&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc41455",
  null
  
)

export default component.exports